// extracted by css-extract-rspack-plugin
export default {"block":"SettingsIslandWithTitleStub_block__d3MHI","header":"SettingsIslandWithTitleStub_header__W8Jbv"};